<template>
  <ul :class="$style.userList">
    <li
      v-for="{ title, label, count } in systemUserSecurityStateCounts"
      :key="title"
      :class="$style.userListItem"
    >
      <h3 :class="$style.countTitle">
        {{ title }}
      </h3>
      <p :class="$style.countLabel">
        <strong> {{ count }}</strong>
        {{ label }}
      </p>
    </li>
    <slot />
  </ul>
</template>

<script>
import { ModuleConsts } from 'client/util/Constants';
import PasswordStatusUtil from 'client/util/PasswordStatusUtil';
import pluralize from 'pluralize';

const { passwordStates } = ModuleConsts.systemUser;

const replaceUserWordToken = '#';

const recipientEmailTypeMapping = {
  active: {
    title: 'Activation email',
    label: `${replaceUserWordToken} will receive an activation email.`,
  },
  resetPassword: {
    title: 'Password reset email',
    label: `${replaceUserWordToken} will receive a password reset email.`,
  },
};

export default {
  name: 'UserSecurityStatusList',

  props: {
    selectedUsers: {
      default: () => [],
      type: Array,
    },
  },

  data() {
    return {
      activationCount: 0,
      passwordResetCount: 0,
    };
  },

  computed: {
    systemUserSecurityStateCounts() {
      const counts = {
        resetPassword: 0,
        active: 0,
      };

      this.selectedUsers.forEach((systemuser) => {
        const securityStatus = PasswordStatusUtil.getPasswordStatus(systemuser);
        if (securityStatus === passwordStates.pending) {
          counts.active += 1;
        } else {
          counts.resetPassword += 1;
        }
      });

      return Object.entries(counts)
        .filter(([, count]) => count > 0)
        .map(this.getLabelForSecurityStatusSysterUser);
    },
  },

  methods: {
    getLabelForSecurityStatusSysterUser([recipientEmailType, count]) {
      const { title, label } = recipientEmailTypeMapping[recipientEmailType];

      return {
        count,
        title,
        label: label.replace(
          replaceUserWordToken,
          `${pluralize('user', count)}`,
        ),
      };
    },
  },
};
</script>

<style module>
.userList {
  list-style: none;
  margin: 0;
  padding: 0;
}

.countTitle {
  margin: 0 0 var(--jc-spacer-x-small);
}

.userList .countLabel {
  margin: 0;
}

.countLabel::first-letter {
  font-weight: bold;
}

.userListItem:not(:last-of-type) {
  margin: 0 0 var(--jc-spacer-medium);
}
</style>
